import React, { useCallback, useState } from 'react';
import ImageViewer from 'react-simple-image-viewer';

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import './Item.scss';
import { IProject } from './App';

SwiperCore.use([Navigation, Pagination]);

interface ComponentProps {
  type?: string;
  list: Array<any>;
}

const SwiperView: React.FC<ComponentProps> = props => {
  const type = props.type;
  const list = props.list;

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = useCallback((index: number) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  return (
    <>
      <Swiper
        direction={'horizontal'}
        slidesPerView={1.5}
        spaceBetween={5}
        mousewheel={true}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
        scrollbar={{ draggable: true }}
        breakpoints={{
          720: {
            slidesPerView: type === 'horizontal' ? 1.3 : 2.5,
          },
          1080: {
            slidesPerView: type === 'horizontal' ? 1.3 : 3.5,
          },
          1440: {
            slidesPerView: type === 'horizontal' ? 1.7 : 4.5,
          },
          1800: {
            slidesPerView: type === 'horizontal' ? 2.3 : 5.5,
          },
          2160: {
            slidesPerView: type === 'horizontal' ? 3.3 : 6.5,
          },
        }}>
        {list?.map((slideItem: any, slideIndex: number) => {
          return (
            <SwiperSlide key={slideIndex}>
              <img
                src={slideItem}
                onClick={() => openImageViewer(slideIndex)}
                alt="Screenshot"
              />
            </SwiperSlide>
          );
        })}
      </Swiper>

      {isViewerOpen && (
        <div style={{ zIndex: 100 }}>
          <ImageViewer
            src={list}
            currentIndex={currentImage}
            disableScroll={false}
            closeOnClickOutside={true}
            onClose={closeImageViewer}
          />
        </div>
      )}
    </>
  );
};

export default SwiperView;
